import { FaCheckCircle } from 'react-icons/fa'
import { SkillAnswer, SkillQuestion } from '../../styles'

interface iFormQuestaoResponse {
  id: string
  tipo: number
  enunciado: string
  alternativas?: iFormAlternativaResponse[]
}

interface iFormAlternativaResponse {
  id: string
  texto: string
}

interface iMultiplaEscolhaProps {
  questao: iFormQuestaoResponse
  isSelect: (perguntaId: string, alternativaId: string) => boolean
  SelecionarQuestao: (perguntaId: string, alternativaId: string) => void
  erro: boolean
}

export const MultiplaEscolha: React.FC<iMultiplaEscolhaProps> = ({ questao, erro, isSelect, SelecionarQuestao }) => {
  return (
    <SkillQuestion>
      <div>
        <h3>{questao.enunciado}</h3>
        {erro && <span>* resposta requerida</span>}
      </div>
      {
        questao.alternativas?.map((r: iFormAlternativaResponse, i2) => {
          return (
            <SkillAnswer
              key={i2}
              type="button"
              isSelected={isSelect(questao.id, r.id)}
              onClick={() => SelecionarQuestao(questao.id, r.id)}
            >
              <FaCheckCircle />
              <span>{r.texto}</span>
            </SkillAnswer>
          )
        })
      }
    </SkillQuestion>
  )
}
